<template>
  <div class="overflow-hidden" :key="$route.fullPath">
    <div class="float-left" style="width: 128px; overflow-y: auto">
      <div class="pt-6" style="min-height: calc(100vh - 135px)">
        <Menu :selectedKeys="[0]"></Menu>
      </div>
    </div>
    <div class="float-right p-6" style="width: calc(100% - 128px)">
      <a-spin :spinning="spinning">
        <div class="">
          <a-tabs v-model="activeKey">
            <a-tab-pane key="1" tab="保函信息">
              <a-card title="基本信息">
                <a-descriptions :column="2" :bordered="false">
                  <a-descriptions-item label="保函编号">{{
                    info.prefix + info.code
                  }}</a-descriptions-item>
                  <a-descriptions-item label="状态">{{
                    findByKey(contractStatus, 'id', info.status, 'name')
                  }}</a-descriptions-item>
                  <div class="break-words">
                    <span class="break-all">
                      <span :style="{ color: 'rgb(68 64 60)' }">项目名称：</span>
                      {{ info.project }}</span>
                  </div>
                  <div class="break-words">
                    <span class="break-all">
                      <span :style="{ color: 'rgb(68 64 60)' }">业主：</span>
                      {{ info.proprietor }}</span>
                  </div>
                  <a-descriptions-item label="担保金额">
                    <div class="text-red-500">
                      {{ info.money }}({{ convertCurrency(info.money) }})
                    </div>
                  </a-descriptions-item>
                  <a-descriptions-item label="担保费">
                    <div class="text-red-500">
                      {{ info.poundage }}({{ convertCurrency(info.poundage) }})
                    </div>
                  </a-descriptions-item>
                  <a-descriptions-item label="开标时间">{{ info.kbdate }}</a-descriptions-item>
                  <a-descriptions-item label="下单时间">{{ info.create_time }}</a-descriptions-item>
                </a-descriptions>
                <template slot="extra">
                  <div v-if="
                    (info.status == 5 || info.status === 11) &&
                    info.kbdate > now &&
                    userInfo.id == info.user_id
                  ">
                    <a-button type="primary" @click="refundFlag = true"
                      v-if="info.ggb != 'yuhuan' && info.ggb != 'taizho' && info.ggb != 'wenlingxz' && info.ggb != 'zhejiang'">申请退保</a-button>
                  </div>
                  <a-button v-if="permission(['contract'], 'exportReport')" type="primary">申请索赔</a-button>
                </template>
              </a-card>
              <template>
                <div>
                  <!-- 隐藏输入框，保持你原来的复制功能 -->
                  <input id="input" style="opacity: 0; position: absolute" />
                  <template v-if="info.status == 4 || (info.status == 5 && info.bcdl == null)">
                    <div class="h-4"></div>
                    <!-- 关键：一行 flex 包裹，两卡片自动等宽/换行 -->
                    <div style="display: flex; gap: 16px; flex-wrap: wrap;">
                      <!-- 左侧：支付信息 -->
                      <a-card title="支付信息" style="flex: 1 1 640px; min-width: 640px;">
                        <a-descriptions :column="2" :bordered="false">
                          <a-descriptions-item label="项目名称">
                            {{ info.project }}
                            <a-icon type="copy" class="cursor-pointer" @click="copy(info.project)" />
                          </a-descriptions-item>

                          <a-descriptions-item label="账户名称">
                            {{ setting.invoice_title }}
                            <a-icon type="copy" class="cursor-pointer" @click="copy(setting.invoice_title)" />
                          </a-descriptions-item>

                          <a-descriptions-item label="付款时间" :contentStyle="{ color: 'red' }">
                            <div class="text-red-500">
                              <span v-if="info.kbdate">请在 {{ info.kbdate }} 前支付</span>
                              <span v-else>请尽量在开标前2小时完成支付</span>
                            </div>
                          </a-descriptions-item>

                          <a-descriptions-item label="开户行">
                            {{ setting.invoice_bank }}
                            <a-icon type="copy" class="cursor-pointer" @click="copy(setting.invoice_bank)" />
                          </a-descriptions-item>

                          <a-descriptions-item label="开户行账号">
                            {{ setting.invoice_bank_account }}
                            <a-icon type="copy" class="cursor-pointer" @click="copy(setting.invoice_bank_account)" />
                          </a-descriptions-item>

                          <a-descriptions-item label="开户行行号">
                            {{ setting.bank_code }}
                            <a-icon type="copy" class="cursor-pointer" @click="copy(setting.bank_code)" />
                          </a-descriptions-item>

                          <a-descriptions-item>
                            <div class="flex">
                              <span class="block mt-2 text-2xl font-bold text-red-500">*</span>
                              <span class="mt-2">汇款用途附言:</span>
                              <span class="text-3xl font-bold text-red-500">{{ info.code }}</span>
                              <a-icon type="copy" class="mt-3 cursor-pointer" @click="copy(info.code)" />
                            </div>
                          </a-descriptions-item>

                          <a-descriptions-item label="金额" :contentStyle="{ color: 'red' }">
                            <div class="text-red-500">
                              {{ info.poundage ? info.poundage.toFixed(2) : '' }}({{
                                convertCurrency(parseFloat(info.poundage ? info.poundage.toFixed(2) : ''))
                              }})
                              <a-icon type="copy" class="text-black cursor-pointer"
                                @click="copy(info.poundage ? info.poundage.toFixed(2) : '')" />
                            </div>
                          </a-descriptions-item>

                          <a-descriptions-item label="申请人">
                            {{ info.bidder }}
                            <a-icon type="copy" class="cursor-pointer" @click="copy(info.bidder)" />
                          </a-descriptions-item>

                        </a-descriptions>

                        <div class="mt-4 text-sm">
                          <div class="text-base font-bold">温馨提示</div>
                          <div>
                            1．保函费汇款转账
                            <span class="text-2xl font-bold text-red-500">用途或附言</span>
                            内容，除序列号以外，请勿备注其他内容。
                          </div>
                          <div>
                            2．如果不是从基本户付款或者登记的基本户账号有误，因此造成的后果由贵公司负责。
                          </div>
                          <div>
                            3．如果一个小时或者更长时间未出函，请
                            <a-upload :before-upload="beforeUpload" :customRequest="api" :show-upload-list="false"
                              accept="image/jpeg,image/png">
                              <a>{{ info.pay_img_src ? '重新上传打款凭证' : '上传打款凭证' }}</a>
                            </a-upload>
                            ，并联系客服人员。
                          </div>
                          <div>4．为防止企业客户信息被泄露，预防措施必不可少，故项目信息开标后解密</div>
                          <div>
                            5．因银行转账存在延迟的问题，请尽量在项目开标或保证金缴纳截至时间前2小时完成支付。
                          </div>
                        </div>

                      </a-card>
                    </div>
                  </template>
                </div>
              </template>
              <div class="h-4"></div>
              <a-card title="企业信息">
                <a-descriptions :column="2" :bordered="false">
                  <a-descriptions-item label="名称">{{ info.bidder }} </a-descriptions-item>
                  <a-descriptions-item label="社会信用代码">{{ info.taxNumber }}
                  </a-descriptions-item>
                  <a-descriptions-item label="地址">{{ info.companyAddress }} </a-descriptions-item>
                  <a-descriptions-item label="开户行">{{ info.bankName }} </a-descriptions-item>
                  <a-descriptions-item label="开户行账号">{{ info.bankAccount }}
                  </a-descriptions-item>
                </a-descriptions>

                <div class="items-center overflow-hidden" v-if="info.temp && info.temp.is_certificate">
                  <CertificateUpload :src="info.company.certificate_src" @upload="certUpload"></CertificateUpload>
                  <div class="ml-20">开户许可证</div>
                </div>
              </a-card>
            </a-tab-pane>
            <a-tab-pane v-if="info.status >= 5" key="3" tab="发票信息">
              <Invoice :id="info.id" :info="info" />
            </a-tab-pane>
            <a-tab-pane key="2" tab="预览" v-if="(info.status == 4 && info.apply_pdf_src) || info.status > 4">
              <Preview :info="info" />
            </a-tab-pane>
          </a-tabs>
        </div>
      </a-spin>
      <Refund :visible="refundFlag" :record="info" @cancel="refundFlag = false" @ok="get"></Refund>
    </div>
  </div>
</template>
<script>
import CertificateUpload from '@/components/CertificateUpload/index';
import dayjs from 'dayjs';
import { contract, contract_statuss, updatePayVoucher } from '@/api/contract';
import { config } from '@/api/config';
import { findByKey } from '@/utils/tool';
import { convertCurrency } from '@/utils/transContent';
import Menu from '@/views/admin/menu/index.vue';
import Preview from './module/preview.vue';
import Invoice from './module/invoice.vue';
import Refund from './module/refund.vue';
import permission from '@/utils/permission';

import { bcdls, bind_contract, review } from '@/api/bcdl';
import { companyCertificateModify } from '@/api/company';
import { mapGetters } from 'vuex';
import { message } from 'ant-design-vue';
export default {
  components: {
    Menu,
    Preview,
    Invoice,
    Refund,
    CertificateUpload,
  },
  data() {
    return {
      permission,
      queryParam: { custom: {}, time: {}, in: {}, like: {}, eq: {} },
      selectedSerial: null,   // 当前选中的流水 id
      serialList: [],          // 流水数组，格式见下方
      submitRemark: "",
      activeKey: '1',
      now: '',
      contractStatus: [],
      info: {},
      setting: {},
      spinning: true,
      refundFlag: false,
      company: {},
      isBound: false,
    };
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler(newId) {
        // 1. 清空旧数据
        this.selectedSerial = null;
        this.serialList = [];
        this.isBound = false;
        // 2. 重新拉取
        this.get().then(() => {
          this.$nextTick(() => this.loadSerialList());
        });
      }
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),
  },
  async mounted() {
    this.now = dayjs().format('YYYY-MM-DD hh:mm:ss');
    this.contractStatus = (await contract_statuss({ current: -1 })).data || [];
    this.setting = (await config(1)) || {};
    setTimeout(() => {
      this.loadSerialList();
    }, 500);
  },
  async activated() {
    if (this.$route.query.tab == '2') {
      this.activeKey = '3';
    } else if (this.$route.query.tab == '4') {
      this.activeKey = '2';
    } else {
      this.activeKey = '1';
    }
    await this.get();
  },
  created() {
  },
  methods: {
    async handleAutoReview() {
      // 1. 先上传正式 PDF（拿到 file_id）
      // 这里假设你已经上传完成，file_id 存在 this.ct.file_id
      const postData = {
        id: this.ct.id,                    // 保函主键
        version: this.ct.version,          // 并发版本号
        content: this.ct.content,        // 审核意见
        content_2: this.ct.content_2,                     // 第二意见
        sign_type: this.ct.sign_type,                      // 1=电子章
        file_id: this.ct.file_id,          // 正式 PDF 文件 id
        file_id2: this.ct.file_id2,                       // 无第二文件
        text: this.ct.text,               // 操作记录备注
        temp_pos: this.ct.temp_pos,                      // 无印章坐标
        project_temp_pos: this.project_temp_pos,              // 无项目级坐标
        is_pass: true                      // 通过
      };
      try {
        await review(postData);            // 导出的 review 方法
        this.$message.success('审核成功');
        // 2. 刷新当前页面数据
      } catch (e) {
        this.$message.error('审核失败：' + (e.message || '请重试'));
      }
    },
    async loadSerialList() {
      if (this.info.status == 4 || this.info.status == 3) {
        this.isBound = false;
      } else { this.isBound = true; }
      const params11 = {
        like: {},
        like_l: {},
        eq: {
          is_writeoff: 0,
          acctName: this.info.bidder,   // 新增
          crAmt: this.info.poundage    // 新增
        },
        in: { pay_type: [1, 6] },
        time: {},
        custom: {}
      };
      if (this.info.bidder == "" || this.info.poundage == 0) {
        return
      }
      let res = await bcdls({
        qp: JSON.stringify(params11),
      },); console.log(params11)
      this.serialList = (res.data || []).map(item => ({
        id: item.id,                       // 单选需要的 value
        createTime: item.tranDate,      // 第一行左边
        amount: parseFloat(item.crAmt || 0), // 第一行右边金额
        serialNo: item.voucher_no + '',            // 第二行流水号
        remark: item.postscript || '-'         // 第三行备注
      }))
    },

    // 刷新按钮
    refreshSerial() {
      this.loadSerialList()
    },
    // 确认并提交
    async confirmSubmit() {
      if (!this.selectedSerial) {
        this.$message.warning('请先选择一条流水')
        return
      }
      const row = this.serialList.find(r => r.id === this.selectedSerial);
      if (!row) return;
      // TODO: 提交选中流水

      const params3 = {
        bankAccount: this.info.bankAccount,
        bcdl_ids: String(row.id),
        bidder: this.info.bidder,
        contract_id: this.info.id,
        poundage: this.info.poundage,
        text: this.submitRemark
      };
      console.log(params3)
      try {
        if (this.info.status == 3) {
          this.handleAutoReview()
          await new Promise(r => setTimeout(r, 500))
        }
        const res = await bind_contract(params3);
        console.log('提交成功', res);
        this.$message.success('提交成功');
        this.submitRemark = '';          // 清空备注
        await this.get();
      } catch (e) {
        console.error('提交失败', e);
        this.$message.error('提交失败：' + (e.message || '请重试'));
      }
      console.log('选中流水ID:', this.selectedSerial)
    },
    // 组件创建时拉一次数据
    async get() {
      this.spinning = true;
      this.info = (await contract(this.$route.params.id)) || {};
      this.spinning = false;
    },
    copyall() {
      return `项目名称 : ${this.info.project}
账户名称 : ${this.setting.invoice_title}
开户行账号 : ${this.setting.invoice_bank_account}
开户行 : ${this.setting.invoice_bank}
开户行行号 : ${this.setting.bank_code}
金额 : ¥ ${this.info.poundage}(${convertCurrency(parseFloat(this.info.poundage.toFixed(2)))})
申请人 : ${this.info.bidder}
汇款用途附言 : ${this.info.code}`;
    },
    findByKey,
    convertCurrency,
    beforeUpload(file) {
      const isLt = file.size / 1024 / 1024 < 50;
      if (!isLt) {
        this.$message.error('上传文件需小于50MB!');
        return false;
      }
      return isLt;
    },
    copy(str) {
      // 创建临时的 textarea 元素（支持换行符）
      const textarea = document.createElement('textarea');
      // 设置样式确保不可见
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      textarea.style.left = '-9999px';
      textarea.style.top = '0';
      textarea.setAttribute('readonly', ''); // 防止移动端键盘弹出
      // 设置要复制的文本（保留换行符）
      textarea.value = str;
      // 添加到DOM中
      document.body.appendChild(textarea);
      // 选中文本
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);
      try {
        // 执行复制命令
        const result = document.execCommand('copy');
        if (result) {
          message.success('复制成功');
        } else {
          console.error('复制命令执行失败');
        }
      } catch (e) {
        console.error('复制失败，请重试~', e);
      } finally {
        // 无论如何都移除临时元素
        document.body.removeChild(textarea);
      }
    },
    async api(e) {
      let formData = new FormData();
      formData.append('file', e.file);
      formData.append('where', 'bidding_file');
      formData.append('style', '1');
      this.spinning = true;
      let res = await this.$uploadfile('/api/v1/file_upload', formData);
      console.log(res);
      await updatePayVoucher({
        id: this.info.id,
        pay_img_id: res.id,
        pay_img_src: res.pathname,
      });
      this.spinning = false;
      this.get();
      this.$message.success('上传成功');
    },
    async certUpload(res) {
      this.company = this.info.company;
      try {
        this.spinning = true;
        this.company.certificate_id = res.id;
        this.company.certificate_src = res.pathname;
        await companyCertificateModify(this.company);
      } catch (error) {
        this.$error({ title: '错误提示', content: error });
      } finally {
        this.spinning = false;
      }
    },
  },
};
</script>
